import { passwordSchema } from '@approvalmax/ui/src/components';
import { z } from 'zod';

export const schema = z.object({
    password: passwordSchema,
});
